import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/styles/index.scss";
import "./vendor";

Vue.config.productionTip = false;

// HACK: inject the `router` object as `$router` into the `store` object
store.$router = router;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
